import { SHELL } from "../shell/shell.const";

const RESALE = 'mercado-secundario';
const RESALE_MARKET = '';
const RESALE_PURCHASE = 'comprar';
const RESALE_SET_ON_SALE = 'oferta';

export const RESALE_ROUTES = {
  RESALE,
  RESALE_MARKET,
  RESALE_PURCHASE,
  RESALE_SET_ON_SALE,

  /** `/s/mercado-secundario` */
  ROUTE_RESALE_MARKET: `${SHELL}/${RESALE}/${RESALE_MARKET}`,
  /** `/s/mercado-secundario/comprar` */
  ROUTE_RESALE_PURCHASE: `${SHELL}/${RESALE}/${RESALE_PURCHASE}`,
  /** `/s/mercado-secundario/vender` */
  ROUTE_RESALE_SET_ON_SALE: `${SHELL}/${RESALE}/${RESALE_SET_ON_SALE}`,
};
